import { BRANDCHOSEN } from "../hooks/config";

export class CategoryFilter {
    categoryName
    filterType = 'category'
    constructor(categoryName) {
        this.categoryName = categoryName
    }

    apply(products) {
      if(products[BRANDCHOSEN] != undefined) products = products[BRANDCHOSEN]
        return products.filter(product => {
            return (product.Categoria.toLowerCase() === this.categoryName.toLowerCase())
        })
    }
}